// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_close {
  height: 100%;
  display: flex;
  padding: 0;
  padding-right: 0.5rem;
}
.dialog_close .close_modal {
  height: 1.9rem;
  margin: auto;
}
.dialog_close .icon_close {
  color: white !important;
}

.dialog_maximize {
  height: 100%;
  display: flex;
  padding: 0;
  padding-right: 0.5rem;
}
.dialog_maximize .maximize_modal {
  height: 1.9rem;
  margin: auto;
}
.dialog_maximize .icon_chevron_up,
.dialog_maximize .icon_chevron_down {
  color: white !important;
}

.btn-toast-action {
  float: right;
}

#toast-container {
  top: 130px;
  right: 80px;
}
#toast-container .toaster-icon {
  background-position: 100% 1rem;
}

.toast-maximized {
  top: 110px !important;
  right: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/core/dialog/dialog.component.scss"],"names":[],"mappings":"AAcA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;AAbF;AAcE;EACE,cAAA;EACA,YAAA;AAZJ;AAcE;EACE,uBAAA;AAZJ;;AAgBA;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,qBAAA;AAbF;AAcE;EACE,cAAA;EACA,YAAA;AAZJ;AAcE;;EAEE,uBAAA;AAZJ;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,UAAA;EACA,WAAA;AAbF;AAcE;EACE,8BAAA;AAZJ;;AAiBA;EACE,qBAAA;EACA,sBAAA;AAdF","sourcesContent":["// @import 'node_modules/angular2-toaster/toaster';\r\n\r\n// .dialog_content {\r\n//   height: calc(100vh - 242px) !important;\r\n//   overflow-y: auto;\r\n//   // overflow: hidden;\r\n// }\r\n\r\n// .dialog_actions {\r\n//   display: grid;\r\n//   grid-template-columns: 1fr auto;\r\n//   padding: 0.7rem;\r\n// }\r\n\r\n.dialog_close {\r\n  height: 100%;\r\n  display: flex;\r\n  padding: 0;\r\n  padding-right: 0.5rem;\r\n  .close_modal {\r\n    height: 1.9rem;\r\n    margin: auto;\r\n  }\r\n  .icon_close {\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n.dialog_maximize {\r\n  height: 100%;\r\n  display: flex;\r\n  padding: 0;\r\n  padding-right: 0.5rem;\r\n  .maximize_modal {\r\n    height: 1.9rem;\r\n    margin: auto;\r\n  }\r\n  .icon_chevron_up,\r\n  .icon_chevron_down {\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n.btn-toast-action {\r\n  float: right;\r\n}\r\n\r\n#toast-container {\r\n  top: 130px;\r\n  right: 80px;\r\n  .toaster-icon {\r\n    background-position: 100% 1rem;\r\n  }\r\n}\r\n\r\n// Toast position when main dialog is maximized\r\n.toast-maximized {\r\n  top: 110px !important;\r\n  right: 10px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
